import React from 'react';
import { concat, includes, map, without } from 'lodash';
import { FormGroup } from '@mui/material';
import { FormSection, PayerCheckbox } from '../..';
import './CheckboxGroup.scss';

export type CheckboxGroupProps<K extends string> = {
  title: string;
  items: Record<K, string>;
  disabled?: boolean;
  selectedItems: K[];
  setSelectedItems: (selected: K[]) => void;
};

const CheckboxGroup = <K extends string>({
  title,
  items,
  selectedItems,
  setSelectedItems,
  disabled,
}: CheckboxGroupProps<K>) => {
  const checkboxItems = map(items, (item: string, key: K) => (
    <PayerCheckbox
      id={`${title}-${String(key)}`}
      key={key.toString()}
      label={item}
      onChange={checked => setSelectedItems(checked ? concat(selectedItems, key) : without(selectedItems, key))}
      checked={includes(selectedItems, key)}
      disabled={disabled}
    />
  ));

  return (
    <FormSection title={title}>
      <FormGroup>
        <div>{checkboxItems}</div>
      </FormGroup>
    </FormSection>
  );
};

export { CheckboxGroup };
